import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { get, map, pick } from "lodash"
import {
  Button,
  Steps,
  Input,
  Tooltip,
  Radio,
  Select,
  Space,
  Popover,
  Table,
} from "antd"

import Loader from "components/Loader"
import { LeftOutlined, RightOutlined } from "@ant-design/icons"
import previewIcon from "../../../images/preview-icon.svg"
import sendProofIcon from "../../../images/send-proof-icon.svg"
import saveCardIcon from "../../../images/save-card.svg"
import alertSvg from "../../../images/alert.svg"
import check from "../../../images/check.svg"
import pencilGray from "../../../images/pencil-gray.svg"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import reducer from "./reducer"
import saga from "./saga"
import questionIcon from "../../../images/question.svg"
import "./index.less"
import {
  makeSelectIsLoadingSegments,
  makeSelectIsLoadingSurveyTypes,
  makeSelectSegments,
  makeSelectSurveyTypes,
  makeSelectScopeTypes,
  makeSelectIsLoadingCreateMeasurement,
  makeSelectIsLoadingOrganizationSurveys,
  makeSelectIsLoadingScopeTypes,
  makeSelectOrganizationSurveys,
  makeSelectSegmentsSurveys,
  makeSelectIsLoadingSegmentsSurveys,
} from "./selectors"

import {
  getOrganizationSurveysWatcher,
  getSegmentsWatcher,
  getSurveyTypesWatcher,
  getScopeTypesWatcher,
  createMeasurementWatcher,
  getSegmentsSurveysWatcher,
} from "./actions"
import { isModuleBySlug, LOCAL_COMPANY_ID, LOCAL_MODULES} from "../../../utils/storage"
import { SEGMENTS } from "../../../utils/constants"
import ModalCustom from "../../../components/ModalCustom"
import { woopraTrack } from "../../../utils/woopra/woopraTracker"
import ModalSendTestSurvey from "../../../components/ModalSendTestSurvey"

const { Step } = Steps
const { Option } = Select

let segmentsAndSurveys = []

export class MeasurementNew extends React.Component {
  state = {
    currentStep: 0,
    surveyType: 1,
    scopeType: 1,
    measureType: 1,
    name: "",
    selectedSegments: [],
    segmentsAndSurveys: [],
    selectedSurvey: undefined,
    clickSaved: false,
  }

  componentDidMount = () => {
    if (!JSON.parse(LOCAL_MODULES()).some(module => module.slug === 'measures')) {
      this.props.history.push("/")
    }
    this.props.getOrganizationSurveysWatcher(this.state.surveyType)
    this.props.getSegmentsWatcher(this.state.surveyType)
    this.props.getSurveyTypesWatcher()
    this.props.getScopeTypesWatcher()
  }

  componentDidUpdate = (prevProps) => {
    if (
      prevProps.organizationSurveys !== this.props.organizationSurveys &&
      !this.props.isLoadingOrganizationSurveys
    ) {
      if (this.props.organizationSurveys.length === 0) {
        this.setState({
          scopeType: 2,
        })
      }
    }
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  saveSurveyIdForSegment = (surveyId, segmentId) => {
    const { segmentsAndSurveys } = this.state
    let push = true
    const newSegmentsAndSurveys = segmentsAndSurveys.map((item) => {
      if (item.id_segment === segmentId) {
        push = false
        return {
          id_segment: segmentId,
          id_survey: surveyId,
        }
      }
      return item
    })
    if (push) {
      newSegmentsAndSurveys.push({
        id_segment: segmentId,
        id_survey: surveyId,
      })
    }
    this.setState({ segmentsAndSurveys: newSegmentsAndSurveys })
  }
  

  saveMeasure = () => {

    let surveyTypes = ['Clima laboral', 'Liderazgo', 'Bienestar', 'Cliente Interno', 'Cultura', 'Offboarding' , 'Onboarding']

    if(this.state.clickSaved) return
    let body = {
      id_company: Number(LOCAL_COMPANY_ID()),
      id_scope_type: this.state.scopeType,
      id_survey_type: this.state.surveyType,
      id_measure_type: this.state.measureType,
      name: this.state.name,
      metric_total_label: surveyTypes[this.state.surveyType - 1],
    }

    if (this.state.scopeType === 1) {
      body = {
        ...body,
        id_survey: this.state.selectedSurvey,
      }
    }
    if (this.state.scopeType === 2) {
      body = {
        ...body,
        id_survey: null,
        segments_has_surveys: this.state.segmentsAndSurveys,
      }
    }
    this.setState({ clickSaved: true });
    this.props.createMeasurementWatcher(body)
  }

  removeSegmentFromSurvey = (segmentId) => {
    const newSegmentsAndSurveys = this.state.segmentsAndSurveys.filter(
      (item) => {
        return item.id_segment !== segmentId
      }
    )
    this.setStateFrom("segmentsAndSurveys", newSegmentsAndSurveys)
  }

  validateFields = () => {
    if (this.state.name === "") {
      return true
    }

    if (this.state.scopeType === 1) {
      if (!this.state.selectedSurvey) {
        return true
      }
    }

    if (this.state.scopeType === 2) {
      if (this.state.selectedSegments.length === 0) {
        return true
      }

      if (
        this.state.selectedSegments.length !==
        this.state.segmentsAndSurveys.length
      ) {
        return true
      }
    }

    return false
  }

  render = () => {
    const {
      isLoadingSegments,
      isLoadingSurveyTypes,
      isLoadingScopeTypes,
      isLoadingCreateMeasurement,
      isLoadingSegmentsSurveys,
      isLoadingOrganizationSurveys,
      segments,
      surveyTypes,
      scopeTypes,
      segmentsSurveys,
      organizationSurveys,
    } = this.props

    const { currentStep, selectedSegments } = this.state

    const isSegmentsEnabled = isModuleBySlug(SEGMENTS)
    let selectedSegmentsWithSurveys = []

    selectedSegments.forEach((segmentId) => {
      const segment = segments.find(
        (segment) => segment.id_segment === segmentId
      )
      selectedSegmentsWithSurveys.push(segment)
    })

    const contentSegment = (
      <div style={{ maxWidth: 300, fontSize: 12, textAlign: "justify" }}>
        Solo será posible seleccionar segmentos que cuenten con al menos un
        cuestionario asociado para el indicador a medir seleccionado.
      </div>
    )
    const hasFreshchat =
      typeof window.Intercom !== "undefined" &&
      window.self === window.top;
    return (
      <React.Fragment>
        <Helmet>
          <title>Encuestas - Mediciones</title>
          <meta name="description" content="Description of MeasurementCreate" />
          {/* <link rel="stylesheet" href="//cdn.quilljs.com/1.2.6/quill.snow.css" /> */}
          <style>{`
            .ant-calendar-picker-container.ant-calendar-picker-container-placement-bottomLeft .ant-calendar-input-wrap {
              display: block;
            }

            .ant-calendar-picker-container.ant-calendar-picker-container-placement-bottomLeft .ant-calendar-body {
              height: auto !important;
              overflow: auto;
            }
          `}</style>
        </Helmet>
        <div className="measurement-create">
          <div
            className="measurement-create-btn-back"
            onClick={() => {
              woopraTrack("Volver al historial de mediciones")
              this.setState({ modalButtonBackHistory: true })
              // this.setStateFrom("modalButtonBackHistory", true)
            }}>
            <LeftOutlined /> Historial de mediciones
          </div>
          <div className="measurement-create-header">
            <div className="measurement-create-header-title">
              <span>Nueva medición</span>
              {get(this.props, "nameMeasurement", "")}
            </div>
          </div>
          <div className="measurement-create-steps">
            <Steps current={currentStep}>
              <Step title="Configurar medición" />
              <Step title="Configurar correo" />
              <Step title="Seleccionar destinatarios" />
              {this.state.scopeType === 2 && <Step title="Data check" />}
              <Step title="Previsualizar" />
              <Step title="Agendar encuesta" />
            </Steps>
          </div>


          {/* CONTENT */}
          <div className="measurement-create-content">
            {isLoadingCreateMeasurement ||
            isLoadingSurveyTypes ||
            isLoadingScopeTypes ? (
              <Loader />
            ) : (
              currentStep === 0 && (
                <div className="measurement-new">
                  <div className="measurement-new-header">
                    <div className="measurement-new-header-title">
                      Configurar medición
                    </div>

                    <span style={{ marginBottom: "4px", marginTop: "12px" }}>
                      <strong style={{ fontWeight: "600", fontSize: "14px" }}>
                        Nombre de la medición<span className="red">*</span>:
                      </strong>
                    </span>
                    <Input
                      style={{ width: "25%", marginBottom: "16px" }}
                      maxLength={200}
                      placeholder="Ejemplo: Clima Laboral 2018"
                      value={this.state.name}
                      onChange={(e) => this.setState({ name: e.target.value })}
                    />
                    <span style={{ marginBottom: "4px" }}>
                      <strong style={{ fontWeight: "600" }}>
                        Indicador a medir<span className="red">*</span>:
                      </strong>
                    </span>
                    <Select
                      style={{ width: "25%", marginBottom: "16px" }}
                      // disabled={this.state.clickedModel}
                      placeholder="Seleccionar tipo"
                      value={this.state.surveyType}
                      onChange={(e) => {
                        this.setState({
                          surveyType: e,
                          scopeType: 1,
                          selectedSurvey: undefined,
                          selectedSegments: [],
                          segmentsAndSurveys: [],
                        })
                        this.props.getOrganizationSurveysWatcher(e)
                        this.props.getSegmentsWatcher(e)
                      }}>
                      {map(surveyTypes, (item, index) => {
                        return (
                          <Option key={index} value={item.id_survey_type}>
                            {item.name}
                          </Option>
                        )
                      })}
                    </Select>
                    {isSegmentsEnabled && (
                      <>
                        <span style={{ marginBottom: "4px" }}>
                          <strong style={{ fontWeight: "600" }}>
                            Alcance<span className="red">*</span>:
                          </strong>
                        </span>
                        <Radio.Group
                          style={{ marginBottom: "12px" }}
                          value={this.state.scopeType}
                          onChange={(e) =>
                            this.setState({
                              scopeType: e.target.value,
                              selectedSurvey: undefined,
                              selectedSegments: [],
                              segmentsAndSurveys: [],
                            })
                          }>
                          <Space direction="vertical">
                            {map(scopeTypes, (item, index) => {
                              if (item.id_scope_type === 1) {
                                return (
                                  <Radio
                                    value={item.id_scope_type}
                                    disabled={organizationSurveys.length === 0}>
                                    {organizationSurveys.length === 0 ? (
                                      <Popover
                                        placement="top"
                                        content='No cuentas con cuestionarios asignados a "Toda la organización" para el indicador.'>
                                        {item.name}
                                      </Popover>
                                    ) : (
                                      <>{item.name} </>
                                    )}
                                  </Radio>
                                )
                              }

                              if (item.id_scope_type === 2) {
                                return segments.length === 0 ? (
                                  <div>
                                    <Popover
                                      placement="top"
                                      content="No cuentas con cuestionarios asignados a segmentos específicos para el indicador.">
                                      <Radio
                                        value={item.id_scope_type}
                                        disabled={segments.length === 0}>
                                        Segmentos
                                      </Radio>
                                    </Popover>
                                    <Popover
                                      placement="top"
                                      content={contentSegment}>
                                      <img
                                        src={questionIcon}
                                        style={{
                                          marginTop: "-8px",
                                          marginLeft: "-10px",
                                        }}
                                      />
                                    </Popover>
                                  </div>
                                ) : (
                                  <Radio
                                    value={item.id_scope_type}
                                    disabled={segments.length === 0}>
                                    {segments.length === 0 ? (
                                      <Popover
                                        placement="top"
                                        content="No cuentas con cuestionarios asignados a segmentos específicos para el indicador.">
                                        Segmentos
                                      </Popover>
                                    ) : (
                                      <>Segmentos </>
                                    )}
                                    <Popover
                                      placement="top"
                                      content={contentSegment}>
                                      <img
                                        src={questionIcon}
                                        style={{
                                          marginLeft: 8,
                                          cursor: "pointer",
                                        }}
                                      />
                                    </Popover>
                                  </Radio>
                                )
                              }
                              return (
                                <Radio value={item.id_scope_type}>
                                  {item.name}
                                </Radio>
                              )
                            })}
                          </Space>
                        </Radio.Group>
                        {this.state.scopeType === 2 && (
                          <Select
                            mode="multiple"
                            allowClear
                            optionFilterProp="name"
                            placeholder="Seleccionar segmentos"
                            maxTagCount={3}
                            maxTagTextLength={14}
                            loading={isLoadingSegments}
                            value={this.state.selectedSegments}
                            style={{
                              width: "25%",
                              marginBottom: "12px",
                              marginTop: "12px",
                            }}
                            onClear={() => {
                              this.setState({
                                selectedSegments: [],
                                segmentsAndSurveys: [],
                              })
                            }}
                            onDeselect={(e) => {
                              this.removeSegmentFromSurvey(e)
                            }}
                            onChange={(e) => {
                              this.setState({ selectedSegments: e })
                              e.forEach((item) => {
                                const segment = segments.find(
                                  (segment) => segment.id_segment === item
                                )
                                if (segment.surveys.length === 1) {
                                  this.saveSurveyIdForSegment(
                                    segment.surveys[0].id_survey,
                                    segment.id_segment
                                  )
                                }
                              })
                            }}>
                            {segments.map((segment, index) => {
                              return (
                                <Option
                                  key={index}
                                  value={segment.id_segment}
                                  name={segment.name}>
                                  {segment.name}
                                </Option>
                              )
                            })}
                          </Select>
                        )}
                      </>
                    )}
                    {this.state.scopeType === 1 && (
                      <>
                        <span
                          style={{
                            marginBottom: "4px",
                          }}>
                          <strong style={{ fontWeight: "600" }}>
                            Cuestionario<span className="red">*</span>:
                          </strong>
                        </span>
                        <Select
                          optionFilterProp="name"
                          style={{ width: "25%", marginBottom: "16px" }}
                          // disabled={this.state.clickedModel}
                          loading={isLoadingOrganizationSurveys}
                          placeholder="Seleccionar cuestionario"
                          value={this.state.selectedSurvey}
                          onChange={(e) =>
                            this.setState({ selectedSurvey: e })
                          }>
                          {map(organizationSurveys, (item, index) => {
                            return (
                              <Option
                                disabled={!item.has_likert_questions}
                                key={index}
                                value={item.id_survey}
                                name={item.name}>
                                  {
                                  !item.has_likert_questions
                                    ?
                                      <Tooltip  title="Este cuestionario no podrá ser utilizado porque no cuenta con preguntas tipo Likert." placement="right">
                                        <span style={{width: '100%', display: 'block' }}>
                                          {item.name}
                                        </span>
                                      </Tooltip>
                                    : item.name
                                  }
                              </Option>
                            )
                          })}
                        </Select>
                      </>
                    )}
                    {this.state.scopeType === 2 && (
                      <>
                        <span
                          style={{
                            marginBottom: "4px",
                          }}>
                          <strong style={{ fontWeight: "600" }}>
                            Cuestionario(s)*:
                          </strong>
                        </span>
                        <span
                          style={{
                            marginBottom: "12px",
                            fontSize: "13px",
                            color: "#4F4F4F",
                          }}>
                          Selecciona el cuestionario a utilizar para cada uno de
                          los segmentos elegidos.
                        </span>
                        {selectedSegments.length > 0 && (
                          <Table
                            bordered
                            style={{ width: "50%" }}
                            pagination={false}
                            size="small"
                            columns={[
                              {
                                title: "Segmento",
                                width: "50%",
                                dataIndex: "name",
                                key: "name",
                                render: (text) => (
                                  <span style={{ color: "#555151" }}>
                                    {text}
                                  </span>
                                ),
                              },
                              {
                                title: "Cuestionario",
                                dataIndex: "survey",
                                width: "50%",
                                key: "survey",
                                render: (text, record) => {
                                  if (record.surveys.length === 1) {
                                    return (
                                      <Select
                                        value={record.surveys[0].id_survey}
                                        onChange={(e) => {
                                          this.saveSurveyIdForSegment(
                                            e,
                                            record.id_segment
                                          )
                                        }}
                                        placeholder="Seleccionar cuestionario"
                                        style={{ width: "100%" }}>
                                        {map(record.surveys, (item, index) => {
                                          return (
                                            <Option
                                              disabled={!item.has_likert_questions}
                                              key={index}
                                              value={item.id_survey}
                                              name={item.name}>
                                                {
                                                !item.has_likert_questions
                                                  ?
                                                    <Tooltip  title="Este cuestionario no podrá ser utilizado porque no cuenta con preguntas tipo Likert." placement="right">
                                                      <span style={{width: '100%', display: 'block' }}>
                                                        {item.name}
                                                      </span>
                                                    </Tooltip>
                                                  : item.name
                                                }
                                            </Option>
                                          )
                                        })}
                                      </Select>
                                    )
                                  }

                                  return (
                                    <Select
                                      placeholder="Seleccionar cuestionario"
                                      onChange={(e) => {
                                        this.saveSurveyIdForSegment(
                                          e,
                                          record.id_segment
                                        )
                                      }}
                                      style={{ width: "100%" }}>
                                      {map(record.surveys, (item, index) => {
                                        return (
                                          <Option
                                            disabled={!item.has_likert_questions}
                                            key={index}
                                            value={item.id_survey}
                                            name={item.name}>
                                              {
                                              !item.has_likert_questions
                                                ?
                                                  <Tooltip  title="Este cuestionario no podrá ser utilizado porque no cuenta con preguntas tipo Likert." placement="right">
                                                    <span style={{width: '100%', display: 'block' }}>
                                                      {item.name}
                                                    </span>
                                                  </Tooltip>
                                                : item.name
                                              }
                                          </Option>
                                        )
                                      })}
                                    </Select>
                                  )
                                },
                              },
                            ]}
                            dataSource={selectedSegmentsWithSurveys}
                          />
                        )}
                      </>
                    )}

                    <span style={{ marginBottom: "4px", marginTop: "12px" }}>
                      <strong style={{ fontWeight: "600", fontSize: "14px" }}>
                        Tipo<span className="red">*</span>:
                      </strong>
                    </span>
                    <Radio
                      checked={this.state.measureType === 1}
                      value={1}
                      onChange={(e) => {
                        this.setState({ measureType: e.target.value })
                      }}>
                      Medición
                    </Radio>
                    <span className="measurement-new-type-description">
                      La medición es representativa de toda la población, por lo
                      que sus resultados serán considerados para el{" "}
                      <strong>análisis de la evolución histórica</strong> del
                      indicador a medir.
                    </span>
                    <Radio
                      checked={this.state.measureType === 2}
                      value={2}
                      onChange={(e) => {
                        this.setState({ measureType: e.target.value })
                      }}>
                      Pulso
                    </Radio>
                    <span className="measurement-new-type-description">
                      La medición <strong>no</strong> es representativa de toda
                      la población, por lo que sus resultados{" "}
                      <strong className="measurement-new-type-description-underline">
                        no
                      </strong>{" "}
                      serán considerados para el{" "}
                      <strong>análisis de la evolución histórica</strong> del
                      indicador a medir, ni contarán con evolución histórica
                      versus mediciones anteriores.
                    </span>
                  </div>
                </div>
              )
            )}
          </div>

          <div className="measurement-create-steps-actions">
            <div>
              {currentStep !== 0 && (
                <Button onClick={() => this.nextStep(-1)}>
                  <LeftOutlined /> Anterior
                </Button>
              )}
            </div>
            <div style={{ ...(typeof window.Intercom !== "undefined" &&
            window.self === window.top && {
            marginRight: "61px"}) }}>
              { !this.validateFields() ?
                <Button
                  type="primary"
                  id="btnSiguiente"
                  onClick={() => {
                    this.saveMeasure()
                  }}>
                  <React.Fragment>
                    Siguiente <RightOutlined style={{ marginLeft: 8 }} />
                  </React.Fragment>
                </Button> :
                <Popover placement="topLeft" content={() => {
                  return currentStep === 3 ?
                    <span>Es necesario seleccionar al<br /> menos una división para<br /> continuar con el proceso.</span>
                    :
                    <span>Es necesario completar todos<br/> los campos para continuar<br/> con el proceso.</span>
                }}>
                  <Button
                    type="primary"
                    disabled={this.validateFields() || this.state.clickSaved}
                    id="btnSiguiente"
                    onClick={() => {
                      this.saveMeasure()
                    }}>
                    <React.Fragment>
                      Siguiente <RightOutlined style={{ marginLeft: 8 }} />
                    </React.Fragment>
                  </Button>
                </Popover>
              }
            </div>
          </div>

          {/* BACK TO HISTORY MEASUREMENT */}
          <ModalCustom
            showFooter
            textButton="Salir"
            modalOpen={this.state.modalButtonBackHistory}
            action="Volver a Historial de mediciones"
            onCancel={() => {
              this.setState({ modalButtonBackHistory: false })
              // this.setStateFrom("modalButtonBackHistory", false)
            }}
            onOk={() => {
              this.props.history.push("/models/measure-history")
            }}>
            <img src={alertSvg} className="alertIcon" />
            <p style={{ fontSize: 14, fontWeight: 600 }}>
              ¿Estás seguro de que deseas salir?
            </p>
            <p style={{ fontSize: 13 }}>
              Se perderán los últimos cambios que no hayan sido guardados.
            </p>
          </ModalCustom>
          <ModalSendTestSurvey
            modalSendTestSurvey={this.state.modalSendTestSurvey}
            setStateFrom={this.setStateFrom}
            {...pick(this.props, ["match", "stepThirdWatcher"])}
          />
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  segments: makeSelectSegments(),
  isLoadingSegments: makeSelectIsLoadingSegments(),
  surveyTypes: makeSelectSurveyTypes(),
  isLoadingSurveyTypes: makeSelectIsLoadingSurveyTypes(),
  scopeTypes: makeSelectScopeTypes(),
  isLoadingScopeTypes: makeSelectIsLoadingScopeTypes(),
  organizationSurveys: makeSelectOrganizationSurveys(),
  isLoadingOrganizationSurveys: makeSelectIsLoadingOrganizationSurveys(),
  segmentsSurveys: makeSelectSegmentsSurveys(),
  isLoadingSegmentsSurveys: makeSelectIsLoadingSegmentsSurveys(),
  isLoadingCreateMeasurement: makeSelectIsLoadingCreateMeasurement(),
})

function mapDispatchToProps(dispatch) {
  return {
    getSegmentsWatcher: (params) => dispatch(getSegmentsWatcher(params)),
    getSurveyTypesWatcher: (params) => dispatch(getSurveyTypesWatcher(params)),
    getScopeTypesWatcher: (params) => dispatch(getScopeTypesWatcher(params)),
    getOrganizationSurveysWatcher: (params) =>
      dispatch(getOrganizationSurveysWatcher(params)),
    getSegmentsSurveysWatcher: (params) =>
      dispatch(getSegmentsSurveysWatcher(params)),
    createMeasurementWatcher: (params) =>
      dispatch(createMeasurementWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "measurementNew", reducer })
const withSaga = injectSaga({ key: "measurementNew", saga })

export default compose(withReducer, withSaga, withConnect)(MeasurementNew)
